import { render } from "./BaseLoader.vue?vue&type=template&id=718f730e"
import script from "./BaseLoader.vue?vue&type=script&lang=js"
export * from "./BaseLoader.vue?vue&type=script&lang=js"

import "./BaseLoader.vue?vue&type=style&index=0&id=718f730e&lang=scss"

import exportComponent from "/Users/malina/mySpace/work/v-art/protocol/template-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__